import React, { Fragment, lazy, Suspense } from "react";
import ExecutionEnvironment from "exenv";
import queryString from "query-string";

// Components
import CustomMeta from "../components/CustomMeta/CustomMeta";
const SinglePostGeneratorTest = lazy(() =>
  import(
    /* webpackChunkName: "SinglePostGeneratorTest" */ "../components/PostGenerator/SinglePostGenerator/SinglePostGeneratorTest"
  )
);

// Redux stuff
import { connect } from "react-redux";
import { updateZoom } from "../redux/actions/templateActions";

function singlePostGeneratorTest(props) {
  const { postID } = queryString.parse(props.location.search);

  return (
    <Fragment>
      <CustomMeta
        title={`${postID} - Single post generator`}
        description={`Used for single post generation`}
        url={`https://contentgenerator.io/singlePostGeneratorTest`}
      />
      {ExecutionEnvironment.canUseDOM && (
        <Suspense fallback={<div />}>
          <SinglePostGeneratorTest />
        </Suspense>
      )}
    </Fragment>
  );
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, { updateZoom })(
  singlePostGeneratorTest
);
